import {
    Button,
    Container,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    Typography,
    CircularProgress,
    TableHead,
    Accordion, 
    AccordionSummary, 
    AccordionDetails
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { getMessstellenLookup, selectMessstellenLoadingLookup, selectMessstellenDictionary } from '../../../features/messstellenLookup/messstellenLookupSlice';
import { rollen, isAuthorized } from "../../../utils/auth/authConfig";
import {
    selectSelectedGruppe,
    selectMesstellenVonGruppe,
    selectMessstellen,
    selectVerfuegbareMessstellen,
    putMessstelleZuGruppe,
    removeMessstelleVonGruppe,
    filterVerfuegbareMessstellen,
    selectGruppentypen,
    selectMessstellenLoading
} from './gruppenverwaltungSlice';
import { useStyles } from './gruppenverwaltungStyles';

export const GruppenverwaltungGrid: React.FC = () => {

    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const selectedGruppe = useAppSelector(selectSelectedGruppe);
    const messstellenVonGruppe = useAppSelector(selectMesstellenVonGruppe);
    const verfuegbareMessstellen = useAppSelector(selectVerfuegbareMessstellen);
    const messstellen = useAppSelector(selectMessstellen);
    const gruppentypen = useAppSelector(selectGruppentypen);
    const messstellenLoading = useAppSelector(selectMessstellenLoading);
    const messstellenDict = useAppSelector(selectMessstellenDictionary);
    const messstellenLoadingLookup = useAppSelector(selectMessstellenLoadingLookup);
    const [expandedMessstelle, setExpandedMessstelle] = React.useState<boolean>(false);
    const filterOptions = [...new Set(messstellen.map(x => x.name).concat(messstellen.map(x => x.umspannwerk)).concat(messstellen.map(x => x.schaltfeld)).concat(messstellen.map(x => x.spannungsebene)).sort((a, b) => a.localeCompare(b)))];

    const [selectedFilter, setSelectedFilter] = React.useState("");
    const onChangeFilter = (filter: string) => {
        setSelectedFilter(filter);
        dispatch(filterVerfuegbareMessstellen(filter));
    }

    const [selectedFilterInput, setSelectedFilterInput] = React.useState("");
    const onChangeFilterInput = (filter: string) => {
        setSelectedFilterInput(filter);
        dispatch(filterVerfuegbareMessstellen(filter));
    }

    const keineGruppeTableCell = (label: string) => {

        return (
            <TableRow hover={true}>
                <TableCell/>
                <TableCell/>
                <TableCell 
                    className={classes.tableHeadlineSub} 
                    style={{ backgroundColor:"white", fontWeight:"600"}} 
                    align="right" >
                        {label}
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
            </TableRow>
        );
    };

    return (
        <Container maxWidth={false} style={{ marginTop: "10px", paddingRight: "10px" }}>
            <Grid item container md={12}>
                <Grid item container md={12} spacing={2} className={classes.paddingPaper} style={{ marginBottom: "20px" }}>
                    <Grid item md={6} >
                        <Paper>
                            <Grid item container md={12}>
                                <Accordion style={{width: "100%", marginBottom:"-3px"}}>
                                    <AccordionSummary>
                                        <Typography className={classes.tableHeadline} variant="h6" style={{marginBottom:"8px",marginLeft:"12px"}}>
                                            {"Messstellen von " + (selectedGruppe.id !== 0 ? selectedGruppe.name + " (" + gruppentypen.find(x => x.id == selectedGruppe.typ)?.name + ")" : "Gruppe")}
                                        </Typography>
                                    </AccordionSummary>
                                </Accordion>
                            </Grid>
                            {messstellenLoading && messstellenLoadingLookup ? 
                                
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{overflow:"hidden"}}>
                                        <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600", textAlign:"center" }}><CircularProgress style={{ padding: "5px"}} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                
                                : (
                                selectedGruppe.id !== 0 ?
                                    <TableContainer style={{ maxHeight: "50vh" }}>
                                        <Table stickyHeader size="small" style={{marginBottom:"50px", overflow:"hidden"}}>
                                            <TableHead>
                                            <TableCell style={{backgroundColor:"white", maxWidth:"12px", width: "12px", padding: "0px"}}/>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Umspannwerk</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Schaltfeld</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Messstelle</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Spannungsebene</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {messstellenVonGruppe.length>0 ? messstellenVonGruppe.map((zugeordneteMessstelle) => (
                                                    <TableRow key={zugeordneteMessstelle.messstelle} hover={true}>
                                                        <TableCell style={{backgroundColor:"white", maxWidth:"12px", width: "12px", padding: "0px"}}/>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, zugeordneteMessstelle.messstelle, "umspannwerk")}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, zugeordneteMessstelle.messstelle, "schaltfeld")}</TableCell>
                                                        <TableCell>{zugeordneteMessstelle.messstelle}</TableCell>
                                                        <TableCell>{zugeordneteMessstelle.spannungsebene}</TableCell>
                                                        {isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft]) ?
                                                            <TableCell>
                                                                <Button color="secondary" onClick={() => dispatch(removeMessstelleVonGruppe(zugeordneteMessstelle))}>
                                                                    Zuordnung aufheben
                                                                </Button>
                                                            </TableCell>
                                                            : ""}
                                                    </TableRow>
                                                )) : keineGruppeTableCell("Keine Gruppe vorhanden")
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    : 
                                        <TableContainer className={classes.heightScrolledTableBottom}>
                                            <Table stickyHeader size="small" style={{marginBottom:"50px", overflow:"hidden"}} >
                                                <TableHead>
                                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} />
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} align="center" >Keine Gruppe ausgewählt</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    
                                )}
                        </Paper>
                    </Grid>
                    <Grid item md={6} >
                        <Paper>
                            <Grid item container md={12} >
                                <Accordion 
                                    expanded={expandedMessstelle} 
                                    onChange={()=> expandedMessstelle ? setExpandedMessstelle(false): setExpandedMessstelle(true)}
                                    style={{width: "100%", marginBottom:"-3px"}}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="ereignis-content"
                                        id="ereignis-header"   
                                        >
                                        <Typography className={classes.tableHeadline} variant="h6" style={{marginBottom:"8px", marginLeft: "12px"}}>Verfügbare Messstellen</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Autocomplete
                                            fullWidth
                                            id="select-filter"
                                            freeSolo
                                            noOptionsText={<React.Fragment>
                                                {messstellenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Kein Ereignis"}</React.Fragment>
                                            }
                                            value={selectedFilter}
                                            onChange={(event, newValue) => onChangeFilter(newValue !== null ? newValue : "")}
                                            inputValue={selectedFilterInput}
                                            onInputChange={(event, newInputValue) => onChangeFilterInput(newInputValue)}
                                            options={filterOptions}
                                            getOptionLabel={(option) => (option ? option : "")}
                                            disableCloseOnSelect
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Filter"
                                                    InputLabelProps={{ ...params.InputLabelProps}}
                                                    InputProps={{ ...params.InputProps }}
                                                    variant="outlined"
                                                />
                                            )}
                                            style={{ paddingRight: "5px", marginBottom:"35px" }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            {messstellenLoading && messstellenLoadingLookup ? 
                                
                                    <TableContainer>
                                        <Table stickyHeader style={{overflow:"hidden"}} >
                                        <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{  backgroundColor:"white", fontWeight:"600", textAlign:"center" }}><CircularProgress style={{ padding: "5px"}} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                
                                : (
                                selectedGruppe.id !== 0 ?
                                    <TableContainer className={expandedMessstelle ? classes.heightScrolledTableTopExpanded : classes.heightScrolledTableTop }>
                                    <Table stickyHeader size="small" style={{marginBottom:"50px"}} >
                                            <TableHead>
                                               <TableCell style={{backgroundColor:"white", maxWidth:"12px", width: "12px", padding: "0px"}}/>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Umspannwerk</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Schaltfeld</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Messstelle</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}>Spannungsebene</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }}></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {verfuegbareMessstellen.length > 0 ? verfuegbareMessstellen.map((messstelle) => (
                                                    <TableRow key={messstelle.name} hover={true}>
                                                        <TableCell style={{backgroundColor:"white", maxWidth:"12px", width: "12px", padding: "0px"}}/>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, messstelle.name, "umspannwerk")}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, messstelle.name, "schaltfeld")}</TableCell>
                                                        <TableCell>{messstelle.name}</TableCell>
                                                        <TableCell>{messstelle.spannungsebene}</TableCell>
                                                        {isAuthorized([rollen.admin, rollen.netzwirtschaft, rollen.technik]) ?
                                                            <TableCell>
                                                                <Button color="secondary" onClick={() => dispatch(putMessstelleZuGruppe(selectedGruppe, messstelle))}>
                                                                    zur Gruppe zuordnen
                                                                </Button>
                                                            </TableCell>
                                                            : ""}
                                                    </TableRow>
                                                )): keineGruppeTableCell("Keine Gruppe vorhanden")
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    :
                                    
                                        <TableContainer className={classes.heightScrolledTableBottom}>
                                            <Table stickyHeader size="small" style={{marginBottom:"50px", overflow:"hidden"}} >
                                                <TableHead>
                                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} />
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} align="center" >Keine Gruppe ausgewählt</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    
                                )}
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
}